// ** Redux Imports
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { put, post } from '../../../../common/api'
import { ADD_ROLE, ADD_ROLE_MODULES, DELETE_ROLE, EDIT_ROLE, GET_ROLE, GET_ROLE_MODULES, MODULES_DETAILS, ROLE} from '../../../../common/constant'

export const actionRoleManagement = createAsyncThunk('appRoleManagement/actionRoleManagement', async (params, thunkAPI) => {
    return await post(ROLE, params, thunkAPI)
})

export const actionGetRoleManagement = createAsyncThunk('appRoleManagement/actionGetRoleManagement', async (params, thunkAPI) => {
    return await post(GET_ROLE, params, thunkAPI)
})

export const actionAddRoleManagement = createAsyncThunk('appRoleManagement/actionAddRoleManagement', async (params, thunkAPI) => {
    return await put(ADD_ROLE, params, thunkAPI)
})

export const actionEditRoleManagement = createAsyncThunk('appRoleManagement/actionEditRoleManagement', async (params, thunkAPI) => {
    return await post(EDIT_ROLE, params, thunkAPI)
})

export const actionModulesDetail = createAsyncThunk('appRoleManagement/actionModulesDetail', async (params, thunkAPI) => {
    return await post(MODULES_DETAILS, params, thunkAPI)
})

export const actionModulePermissionGet = createAsyncThunk('appRoleManagement/actionModulePermissionGet', async(params, thunkAPI) => {
    return await post(GET_ROLE_MODULES, params, thunkAPI)
})

export const actionModulePermissionAdd = createAsyncThunk('appRoleManagement/actionModulePermissionAdd', async (params, thunkAPI) => {
    return await put(ADD_ROLE_MODULES, params, thunkAPI)
})

export const actionDeleteRole = createAsyncThunk('appRoleManagement/actionDeleteRole', async (params, thunkAPI) => {
    return await post(DELETE_ROLE, params, thunkAPI)
})

export const appRoleManagementSlice = createSlice({
    name: 'appRoleManagement',
    initialState: {
        //list
        loading: false,
        roleManagement: null,

        //get
        loadingGet: false,
        getRoleManagement: null,

        //add
        loadingAdd: false,
        addRoleManagement: null,

        //edit
        loadingEdit: false,
        editRoleManagement: null,

        //module details
        loadingModululesDetails: false,
        modulesDetails: null,
    
        // Get module permission
        loadingModulePermissionsGet: false,
        modulePermissionsGet: null,

        //Add module permission
        loadingModulePermissionsAdd: false,
        modulePermissionsAdd: null,

         //delete
         loadingDelete: false,
         deleteRole: null
    },
    reducers: {
        //reset or delete Add Insurance Company store data
        resetRoleResponse: (state) => {
            state.roleManagement = null
        },
        resetGetRoleManagementResponse: (state) => {
            state.getRoleManagement = null
        },
        resetAddRoleManagementResponse: (state) => {
            state.addRoleManagement = null
        },
        resetEditRoleManagementResponse: (state) => {
            state.editRoleManagement = null
        },
        resetModulesDetailsResponse: (state) => {
            state.modulesDetails = null
        },
        resetGetModulePermissionResponse: (state) => {
            state.modulePermissionsGet = null
        },
        resetAddModulePermissionResponse: (state) => {
            state.modulePermissionsAdd = null
        },
        resetDeleteRoleResponse: (state) => {
            state.deleteRole = null
        }
    },
    extraReducers: builder => {
        builder
            //list
            .addCase(actionRoleManagement.pending, (state) => {
                state.loading = true
            })
            .addCase(actionRoleManagement.fulfilled, (state, action) => {
                state.loading = false
                state.roleManagement = action.payload
            })
            .addCase(actionRoleManagement.rejected, (state) => {
                state.loading = false
            })

            //get
            .addCase(actionGetRoleManagement.pending, (state) => {
                state.loadingGet = true
            })
            .addCase(actionGetRoleManagement.fulfilled, (state, action) => {
                state.loadingGet = false
                state.getRoleManagement = action.payload
            })
            .addCase(actionGetRoleManagement.rejected, (state) => {
                state.loadingGet = true
            })

            //add
            .addCase(actionAddRoleManagement.pending, (state) => {
                state.loadingAdd = true
            })
            .addCase(actionAddRoleManagement.fulfilled, (state, action) => {
                state.loadingAdd = false
                state.addRoleManagement = action.payload
            })
            .addCase(actionAddRoleManagement.rejected, (state) => {
                state.loadingAdd = false
            })

            //edit
            .addCase(actionEditRoleManagement.pending, (state) => {
                state.loadingEdit = true
            })
            .addCase(actionEditRoleManagement.fulfilled, (state, action) => {
                state.loadingEdit = false
                state.editRoleManagement = action.payload
            })
            .addCase(actionEditRoleManagement.rejected, (state) => {
                state.loadingEdit = false
            })

            //get Module details
            .addCase(actionModulesDetail.pending, (state) => {
                state.loadingModululesDetails = true
            })
            .addCase(actionModulesDetail.fulfilled, (state, action) => {
                state.loadingModululesDetails = false
                state.modulesDetails = action.payload
            })
            .addCase(actionModulesDetail.rejected, (state) => {
                state.loadingModululesDetails = false
            })

            //get Module Permission
            .addCase(actionModulePermissionGet.pending, (state) => {
                state.loadingModulePermissionsGet = true
            })
            .addCase(actionModulePermissionGet.fulfilled, (state, action) => {
                state.loadingModulePermissionsGet = false
                state.modulePermissionsGet = action.payload
            })
            .addCase(actionModulePermissionGet.rejected, (state) => {
                state.loadingModulePermissionsGet = true
            })

            //add Module Permission
            .addCase(actionModulePermissionAdd.pending, (state) => {
                state.loadingModulePermissionsAdd = true
            })
            .addCase(actionModulePermissionAdd.fulfilled, (state, action) => {
                state.loadingModulePermissionsAdd = false
                state.modulePermissionsAdd = action.payload
            })
            .addCase(actionModulePermissionAdd.rejected, (state) => {
                state.loadingModulePermissionsAdd = false
            })

            //delete
            .addCase(actionDeleteRole.pending, (state) => {
                state.loadingDelete = true
            })
            .addCase(actionDeleteRole.fulfilled, (state, action) => {
                state.loadingDelete = false
                state.deleteRole = action.payload
            })
            .addCase(actionDeleteRole.rejected, (state) => {
                state.loadingDelete = false
            })

    }
})
export const { resetAddRoleManagementResponse, resetRoleResponse, resetGetRoleManagementResponse, resetEditRoleManagementResponse, resetModulesDetailsResponse, resetGetModulePermissionResponse, resetAddModulePermissionResponse, resetDeleteRoleResponse } = appRoleManagementSlice.actions

export default appRoleManagementSlice.reducer